const saved = {
    en: {
        saved: {
            pageTitle: 'Saved Words',
            pageDescription: 'Your personal collection of bookmarked translations. Tap the bookmark icon on any translation to save it here.',
            wordsLabel: 'Words',
            emptyTitle: 'No saved words yet',
            emptyDesc: 'Tap the bookmark icon on any translation card to save words here.',
            originalLabel: 'Original Text',
            originalWithLang: '{lang} (Original)',
            confirmDeleteTitle: 'Remove Saved Word',
            confirmDeleteMessage: 'Are you sure you want to remove this word from your saved collection?',
            tableAria: 'Saved words history table',
            col: {
                original: 'Source Text',
                translated: 'Saved Translation',
                target: 'Target',
                actions: 'Actions',
            },
        },
    },
    th: {
        saved: {
            pageTitle: 'คำที่บันทึก',
            pageDescription: 'คลังคำแปลที่คุณบันทึกไว้ แตะไอคอนบุ๊กมาร์กบนการแปลใดก็ได้เพื่อบันทึกไว้ที่นี่',
            wordsLabel: 'คำ',
            emptyTitle: 'ยังไม่มีคำที่บันทึก',
            emptyDesc: 'แตะไอคอนบุ๊กมาร์กบนการ์ดการแปลเพื่อบันทึกคำไว้ที่นี่',
            originalLabel: 'ข้อความต้นฉบับ',
            originalWithLang: '{lang} (ต้นฉบับ)',
            confirmDeleteTitle: 'ลบคำที่บันทึก',
            confirmDeleteMessage: 'คุณแน่ใจหรือไม่ว่าต้องการลบคำนี้ออกจากคลังที่บันทึกไว้?',
            tableAria: 'ตารางคำที่บันทึก',
            col: {
                original: 'ข้อความต้นฉบับ',
                translated: 'คำแปลที่บันทึก',
                target: 'ปลายทาง',
                actions: 'จัดการ',
            },
        },
    },
};

export default saved;
